import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@rossum/ui/material';

export const PreviousValue = ({ children }: { children: ReactNode }) => {
  const intl = useIntl();
  return (
    <>
      <Typography variant="body2" color="text.disabled">
        {intl.formatMessage({ id: 'features.documentHistory.value.from' })}
      </Typography>
      {children}
    </>
  );
};
